// extracted by mini-css-extract-plugin
export default {"base":"-cm_e11e520f","primaryButton":"-cm_cca3d973","secondaryButton":"-cm_4a1c31a7"};